import GuideLayout from '@/pages/shared/GuideLayout';

export default function GuideSchedule() {
  return (
    <GuideLayout
      title="プロジェクトスケジュール管理の方法とコツ｜”おもいむすび”"
      description="プロジェクトのスケジュール管理を効率的に行う方法を解説。WBSからのスケジュール作成、依存関係の考慮、クリティカルパス管理、国別祝日を考慮したグローバルスケジュール管理まで。"
      keywords="プロジェクト管理 スケジュール管理,プロジェクト スケジュール 作成,プロジェクト 工程管理,プロジェクト 納期管理"
      canonical="https://omoimusubi.asia/guides/project-schedule-management/"
      h1="プロジェクトスケジュール管理の方法と効率化のコツ"
      subtitle="プロジェクトのスケジュールを適切に管理し、遅延を防ぐための方法を解説します。"
      relatedFeatures={[
        { label: 'AIガントチャート', path: '/features/ai-gantt/' },
        { label: '多言語・多国祝日', path: '/features/multilingual/' },
        { label: 'AIタスク分解', path: '/features/ai-task-breakdown/' },
      ]}
      relatedGuides={[
        { label: 'ガントチャートとは', path: '/guides/gantt-chart/' },
        { label: 'クリティカルパスとは', path: '/guides/critical-path/' },
        { label: 'プロジェクトマイルストーン', path: '/guides/project-milestone/' },
        { label: 'プロジェクト依存関係', path: '/guides/project-dependency/' },
      ]}
    >
      <section>
        <h2>スケジュール管理の基本</h2>
        <p>スケジュール管理は、プロジェクトの各タスクの開始日と終了日を計画し、進捗に応じて調整することです。WBSで洗い出したタスクをガントチャートに配置し、依存関係やクリティカルパスを考慮しながら管理します。</p>
      </section>

      <section>
        <h2>スケジュール作成の6ステップ</h2>
        <ol>
          <li><strong>WBSでタスクを洗い出す</strong>：プロジェクトに必要な作業をすべてリストアップします。作業の抜け漏れがあると、後々のスケジュール遅延に直結します。</li>
          <li><strong>タスクの順序関係を整理する</strong>：どのタスクがどのタスクの前に完了している必要があるか、依存関係を明確にします。</li>
          <li><strong>各タスクの所要期間を見積もる</strong>：過去の実績や担当者の経験をもとに、各タスクの所要日数を見積もります。</li>
          <li><strong>担当者を割り当てる</strong>：各タスクに適切な担当者をアサインします。このとき、担当者の稼働状況やスキルセットを考慮します。</li>
          <li><strong>ガントチャートを作成する</strong>：タスクを時系列に並べ、ガントチャートとして視覚化します。</li>
          <li><strong>クリティカルパスを特定する</strong>：プロジェクトの最短完了日数を決める経路を特定し、重点管理対象とします。</li>
        </ol>
      </section>

      <section>
        <h2>スケジュール管理でよくある失敗と対策</h2>
        <h3>失敗1：楽観的な見積もり</h3>
        <p>「これくらいならできるだろう」という楽観的な見積もりにより、計画段階から無理が生じます。過去の類似プロジェクトの実績データを参考に、現実的な見積もりを心がけましょう。</p>
        <h3>失敗2：依存関係の見落とし</h3>
        <p>タスク間の依存関係を見落とすと、あるタスクの遅れが連鎖的に広がります。WBS作成時に関係者全員で依存関係を確認することが重要です。</p>
        <h3>失敗3：バッファ不足</h3>
        <p>予期せぬ問題や手戻りに備えたバッファ（余裕）を確保していないと、一つの問題がプロジェクト全体の遅延につながります。全体スケジュールの10〜20%程度のバッファを確保しましょう。</p>
      </section>

      <section>
        <h2>グローバルチームのスケジュール管理</h2>
        <p>海外拠点や多国籍チームでは、国による祝日や稼働日の違いがスケジュール管理を複雑にします。”おもいむすび”の多言語・多国祝日対応機能では、メンバーごとに所属国を設定することで、各国の祝日を自動で考慮したスケジュールをAIが計算します。「日本の祝日には日本メンバーが休み、タイの祝日にはタイメンバーが休み」といった管理が可能です。</p>
      </section>

      <section>
        <h2>AIによるスケジュール最適化</h2>
        <p>”おもいむすび”では、AIがタスクの依存関係やメンバーの稼働状況、国別の祝日を考慮してスケジュールを自動計算します。計画変更時にも、影響を受けるタスクを自動で再計算するため、スケジュール調整の手間が大幅に削減されます。また、遅延が発生した場合、クリティカルパスへの影響をAIが即座に分析し、管理者に通知します。</p>
      </section>
    </GuideLayout>
  );
}